import { Box, Grid, Typography, useTheme } from "@mui/material";
import ProgressContent from "./ProgressContent";
import InfoContent from "./InfoContent";

import { IorderInfo } from "..";
import ShareIcon from "../../../../../../../../../media/images/icons/share-icon";

export default function FerightInfo(props: IorderInfo) {
  const theme = useTheme();

  return (
    <Grid container>
      <Grid item xs={3.5}>
        <Box
          sx={{
            // border: "1px solid gray",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <ProgressContent {...props} />
          <Box
            sx={{
              backgroundColor: "secondary.light",
              mt: 1,
              borderRadius: "8px",
              borderWidth: "1px",
              borderStyle: "solid",
              borderColor: "secondary.main",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              padding: "4px",
            }}
          >
            <ShareIcon size={20} color={theme.palette.secondary.main} />
            <Typography
              noWrap
              sx={{
                textAlign: "center",
                color: "secondary.main",
                fontSize: "10px",
              }}
            >
              اشتراک‌گذاری بار
            </Typography>
          </Box>
          <Box
            sx={{
              flex: "1",
              backgroundColor: "secondary.light",
              mt: 1,
              borderRadius: "8px",
              borderWidth: "1px",
              borderStyle: "solid",
              borderColor: "secondary.main",
              padding: "4px",
            }}
          >
            <ShareIcon size={20} color={theme.palette.secondary.main} />
            <Typography
              whiteSpace={"wrap"}
              sx={{
                color: "secondary.main",
                fontSize: "10px",
                width: "fit-content",
              }}
            >
              شما می‌توانید موقعیت مکانی وسیله نقلیه و اطلاعات بار را به اشتراک
              بگذارید{" "}
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid
        item
        xs={8.5}
        sx={{
          paddingRight: "4px",
        }}
      >
        <InfoContent {...props} />
      </Grid>
    </Grid>
  );
}
